import { Outlet } from 'react-router-dom';
import Header from '../../components/Headers/Header';
import { Navigate } from 'react-router-dom';

const AuthLayout: React.FC<any> = () => {
  return (
    <div style={styles.container}>
      <Header loggedIn={false} />
      <div style={styles.pageContainer}>
        {window.location.pathname === '/web' || window.location.pathname === '/' ? (
          <Navigate to={'/web/login'} />
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  );
};
const styles = {
  container: {
    minHeight: '100vh',
    background: '#F4F7FD',
    display: 'flex',
    flexDirection: 'column',
  } as React.CSSProperties,
  pageContainer: {
    display: 'flex',
    flex: 'column',
    flexGrow: 1,
    justifyContent: 'center',
  },
};

export default AuthLayout;
